//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  methods: {
    goBacks: function goBacks() {
      this.$router.push("/login");
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
};